<template>
    <Modal class="popup_content" v-model="delivergoodsShows" width="560" @on-cancel="delivergoodsCancel">
        <div slot="header" class="popup_header_content">
            <span>确认发货</span>
        </div>
        <div class="popup_head_body">
            <div class="delivergoods_body">
                <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="90" :show-message="false" :editable="false">
                    <FormItem label="发货日期：" prop="datetiem">
                        <DatePicker :value="formValidate.datetiem" format="yyyy-MM-dd HH:mm" type="datetime" @on-change="datetimeChange" placeholder="选择发货日期" style="width: 300px;"></DatePicker>
                    </FormItem>
                    <FormItem label="物流公司：" prop="logistics">
                        <Input v-model="formValidate.logistics" placeholder="请输入物流公司名称" style="width: 300px;"></Input>
                    </FormItem>
                    <FormItem label="物流单号：" prop="ordernum">
                        <Input v-model="formValidate.ordernum" placeholder="请输入物流单号" style="width: 300px;"></Input>
                    </FormItem>
                </Form>
            </div>
        </div>
        <div slot="footer" class="popup_footer_content">
            <Button type="warning" size="large" @click="delivergoodsOk">提交</Button>
        </div>
    </Modal>
</template>

<script>
    export default {
        props: ['delivergoodsShow', 'delivergoodsInfo'],
        data() {
            const ordernumPass = (rule, value, callback) => { // 判断物流单号是否是数字
                if (value === '') {
                    callback(new Error())
                } else {
                    if (isNaN(value)) {
                        this.tips = false
                        this.$Message.error('订单号必须为数字')
                        callback(new Error())
                    } else {
                        this.tips = true
                    }
                    callback()
                }
            }
            return {
                delivergoodsShows: false, // 弹窗是否显示
                tips: true, // 是否可以使用通用提示
                formValidate: { // 表单内容
                    datetiem: '',
                    logistics: '',
                    ordernum: '',
                },
                ruleValidate: { // 表单验证
                    datetiem: [{required: true, trigger: 'change'}],
                    logistics: [{required: true, trigger: 'blur'}],
                    ordernum: [{required: true, validator: ordernumPass, trigger: 'blur'}],
                }
            }
        },
        methods: {
            datetimeChange (e) {
                this.formValidate.datetiem = e
            },
            delivergoodsOk () {
                this.$refs.formValidate.validate((valid) => {
                    if (valid) {
                        this.delivergoodsShows = false
                        this.$emit('delivergoodsOk', this.formValidate)
                    } else {
                        if (this.tips) this.$Message.error('请填写完整信息！')
                    }
                })
            },
            delivergoodsCancel () {
                this.delivergoodsShows = false
                this.$emit('delivergoodsCancel')
            }
        },
        watch: {
            delivergoodsShow () {
                this.delivergoodsShows = this.delivergoodsShow
                if (this.delivergoodsInfo != undefined) {
                    this.formValidate.datetiem = this.delivergoodsInfo.sendtime
                    this.formValidate.logistics = this.delivergoodsInfo.returnfirm
                    this.formValidate.ordernum = this.delivergoodsInfo.returnodd
                }
            }
        }
    }
</script>

<style scoped>

.delivergoods_body {
    padding: 0 0 0 60px;
}

.delivergoods_body .ivu-form-item {
    margin-bottom: 20px;
}

.delivergoods_body .ivu-form-item:last-child {
    margin-bottom: 0;
}

</style>


// WEBPACK FOOTER //
// src/components/component/popup/delivergoods.vue